<template>
  <div>
    <Alert show-icon class="ivu-mt" v-if="canSelect">
      <div v-font="14">
        已选择<strong v-color="'#2d8cf0'">{{ selectedData.length }}</strong>
        <a class="ivu-ml" @click="handleClearSelect">清空勾选</a>
      </div>
    </Alert>
    <p v-if="false" style="height: 20px"></p>
    <Table
      border
      :height="heightTemp"
      :style="{ height: height }"
      ref="selection"
      :loading="loading"
      :columns="columns"
      :data="pageData.rows"
      @on-row-click="rowClick"
      @on-sort-change="sortChange"
      @on-select="handleSelect"
      @on-select-cancel="handleSelectCancel"
      @on-select-all="handleSelectAll"
      @on-select-all-cancel="handleSelectAllCancel"
    >
    </Table>
    <div style="margin-left: 1%;margin-top: 10px;">
      <Page
        :placement="'top'"
        :total="pageData.total"
        :current="page"
        :page-size="pageSize"
        show-sizer
        show-elevator
        show-total
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
      />
    </div>
  </div>
</template>

<script>
/**
 * ab通用列表页，使用参考userList.vue
 */
import Vue from "vue";
import { mapState } from "vuex";
export default {
  name: "abGrid",
  components: {},
  props: ["url", "height", "searchParam", "flush", "routerType"],
  data() {
    return {
      loading: true,
      heightTemp: "",
      page: 1,
      pageSize: 10,
      canSelect: false,
      sort: "",
      order: "",
      columns: [],
      pageData: {
        rows: [],
        total: 10,
      },
      dialog: {},
      selectedData: [],
      dictMap: {},
      deepKeys: [], // 多层的key
      recive: "",
    };
  },
  mounted: function() {
    this.calcTableListHeight();
    var that = this;
    window.onresize = function() {
      that.calcTableListHeight(true);
    };
  },
  created: function() {
    //解析solt中的column
    this.powelTable();
  },
  computed: {
    ...mapState(["changeTab"]),
  },

  methods: {
    // 封装列表项的方法
    powelTable() {
      this.$slots.default.forEach((item) => {
        if (item.tag != "column") {
          return;
        }
        if (item.data.key) {
          item.data.attrs["key"] = item.data.key;
          this.handleColumnKey(item);
        }

        if (item.data.attrs["sort"]) {
          item.data.attrs["sortable"] = "custom";
        }

        if (item.data.attrs["temp"]) {
          this.handleColumnTemp(item);
        }

        if (item.data.attrs["minWidth"]) {
          item.data.attrs["minWidth"] = Number(item.data.attrs["minWidth"]);
        }

        if (item.data.attrs["val-text"] || item.data.attrs["val-style"]) {
          this.handleColumnValTextStyle(item);
        }

        if (item.data.attrs["date-format"] != null) {
          this.handleColumnDateFormat(item);
        }

        if (item.data.attrs["dict-key"] != null) {
          this.handleColumnDict(item);
        }

        if (item.data.attrs["type"] === "selection") {
          this.canSelect = true;
        }

        if (item.data.attrs["obj-key"]) {
          this.handleColumnObjKey(item);
        }
        if (item.data.attrs.key && item.data.attrs.key.indexOf(".") >= 0) {
          this.deepKeys.push(item.data.attrs.key);
        }
        this.columns.push(item.data.attrs);
      });
      this.postPageData();
    },

    // 计算高度
    calcTableListHeight: function(isResize) {
      if (this.height) return;
      this.heightTemp = document.body.clientHeight; //

      // 顶部高度
      var header = document.querySelectorAll(".ivu-layout-header");
      if (header[0]) {
        this.heightTemp -= header[0].offsetHeight;
      }
      // tabs栏
      var tabs = document.querySelectorAll(".i-layout-tabs");
      if (tabs[0]) {
        this.heightTemp -= tabs[0].offsetHeight;
      }
      // cardHead
      var cardHead = document.querySelectorAll(".ivu-card-head");
      if (cardHead[0]) {
        this.heightTemp -= cardHead[0].offsetHeight;
      } else {
        this.heightTemp -= 29;
      }
      // 查询栏
      var searchForm = document.querySelectorAll(".ivu-card-body>form");
      if (searchForm[0]) {
        this.heightTemp -= searchForm[0].offsetHeight;
      }
      // 按钮栏
      var button = document.querySelectorAll(".ivu-card-body>.ivu-btn");
      if (button[0]) {
        this.heightTemp -= button[0].offsetHeight;
      }
      // 分页栏
      var page = document.querySelectorAll(".ivu-page");
      if (page[0]) {
        this.heightTemp -= page[0].offsetHeight;
      }
      // 底部栏
      var footer = document.querySelectorAll(".ivu-global-footer");

      if (footer[footer.length - 1]) {
        this.heightTemp -= footer[footer.length - 1].offsetHeight;
      }

      // 减去ivu-card-body的padding
      this.heightTemp -= 16 * 2;

      // 减去i-layout-content-mainy的margin-bottom
      this.heightTemp -= 16;

      // 选择栏
      if (this.canSelect) {
        this.heightTemp = this.heightTemp - 60;
      } else {
        this.heightTemp = this.heightTemp - 8;
      }

      if (isResize) {
        this.heightTemp -= 32;
      }

      // 加10的偏移量
      this.heightTemp += 10;
    },
    //单击行修改选中状态
    rowClick: function(item, index) {
      if (this.routerType == undefined) {
        return;
      }
      // !已收公告-gri
      // !个人经办公告
      if (this.routerType == "noticeList") {
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          name: "indexNoticeDetail",
          query: { id: item.id, from: "manager" },
        });
        return;
      }
      // !我的草稿
      if (this.routerType == "noticeDarft") {
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          path: "/notice/indexNoticeDetail",
          query: { id: item.id, from: "manager" },
        });
        return;
      }
      // !公告删除
      if (this.routerType == "deleteNotice") {
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          name: "indexNoticeDetail",
          query: { id: item.id, from: "manager" },
        });
        return;
      }
      //!首页我的待办
      if (this.routerType == "taskCompleteTodo") {
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          name: "taskComplete",
          params: { id: item.id },
        });
        return;
      }
      // !首页我的已办
      if (this.routerType == "taskCompleteDo") {
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          name: "instanceDetail",
          query: { nodeId: item.nodeId },
          params: { id: item.id },
        });
        return;
      }
      // !首页我的发起
      if (this.routerType == "taskCompleteStart") {
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          name: "instanceDetail",
          query: { nodeId: "StartNoneEvent" },
          params: { id: item.id },
        });
        return;
      }
      //!首页收文已办
      if (this.routerType == "recevie") {
        this.recive = "instanceDetail";
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          name: this.recive,
          params: {
            id: item.bpmTaskApprove.id,
            nodeId: item.bpmTaskApprove.nodeId,
          },
        });
        return;
      }
      //!我的待办 议题
      if (this.routerType == "taskCompleteYiti") {
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          name: "taskComplete",
          params: { id: item.bpmTask.taskId, backRouter: "issues" },
        });
        return;
      }
      // ! 我的已办 议题
      if (this.routerType == "instanceDetailYiti") {
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          name: "instanceDetail",
          params: { id: item.bpmTaskApprove.id, backRouter: "issues" },
        });
        return;
      }
      // !我的发起 议题
      if (this.routerType == "instanceDetailDo") {
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          name: "instanceDetail",
          params: { id: item.bpmInstance.id, backRouter: "issues" },
        });
        return;
      }
      //!我的草稿 议题
      if (this.routerType == "draftStart") {
        this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
          .objData[index]._isChecked;
        this.$router.push({
          name: this.routerType,
          params: { id: item.bpmInstance.id, backRouter: "issues" },
        });
        return;
      }
      this.$refs.selection.objData[index]._isChecked = !this.$refs.selection
        .objData[index]._isChecked;
      this.$router.push({ name: this.routerType, params: { id: item.id } });
    },
    //选择分页
    pageChange: function(page) {
      this.page = page;
      this.postPageData();
    },
    //选择页面大小
    pageSizeChange: function(pageSize) {
      this.page = 1;
      this.pageSize = pageSize;
      this.postPageData();
    },

    //排序
    sortChange: function(data) {
      this.order = data.order;
      this.sort = data.column.sort || data.key;
      this.postPageData();
    },
    loadPageData: function() {
      this.postPageData();
    },
    //获取页面数据
    postPageData: function() {
      let param = {
        offset: (this.page - 1) * this.pageSize,
        limit: this.pageSize,
        sort: this.sort,
        order: this.order,
      };
      if (this.searchParam) {
        this.abTools.extend(this.searchParam, param);
      }
      this.loading = true;
      let post = Vue.abHttpUtil.postForm(this.url, param);
      post.then(
        (result) => {
          this.loading = false;
          result = this.abTools.FastJson.format(result);
          this.$emit("postPageData", result);
          this.handleInitData(result);
          this.pageData = result;
        },
        function(status) {
          if (status == !0) {
            Vue.prototype.$Message.error("加载失败！" + status);
          }
        }
      );
    },
    //点击发送行为
    sendAction: function(title, url, params, confirmTxt, successMsg) {
      this.$Modal.confirm({
        title: "温馨提示",
        content: confirmTxt || "确认" + title + "吗？",
        onOk: () => {
          let post = Vue.abHttpUtil.postForm(url.format(params), {});
          Vue.abTools.getResultMsg(post, (data, result) => {
            $.Dialog.success(successMsg || result.msg || "操作成功");
            this.postPageData();
          });
        },
      });
    },
    //处理字段temp属性
    handleColumnTemp(item) {
      item.data.attrs["render"] = (h, params) => {
        let temp = this.$scopedSlots[item.data.attrs["temp"]](params);
        temp.forEach((ite) => {
          if (!ite || !ite.data || !ite.data.attrs) return;

          if (ite.data.attrs["send-action"]) {
            ite.data.on = {
              click: () => {
                this.sendAction(
                  ite.data.attrs["send-action"],
                  ite.data.attrs.url,
                  params,
                  ite.data.attrs["confirm-txt"] ||
                    ite.data.attrs["confirmTxt"] ||
                    ite.data.attrs["confirmMsg"] ||
                    ite.data.attrs["confimMsg"] ||
                    ite.data.attrs["confirm-msg"],
                  ite.data.attrs["success-msg"] ||
                    ite.data.attrs["success-txt"] ||
                    ite.data.attrs["successMsg"] ||
                    ite.data.attrs["successTxt"]
                );
              },
            };
          }
          if (ite.data.attrs["open-dialog"]) {
            var openDialog = ite.data.attrs["open-dialog"]; //要打开内容的指令名字
            var dialogTitle = ite.data.attrs["dialog-title"] || "对话框";
            if (!this.dialog[params.index]) {
              this.$set(this.dialog, params.index, {});
            }
            if (!this.dialog[params.index][openDialog]) {
              this.$set(this.dialog[params.index], openDialog, false);
            }
            var modal = h(
              "Modal",
              {
                props: {
                  title: dialogTitle,
                  footerHide: true,
                  value: this.dialog[params.index][openDialog],
                },
                on: {
                  input: (event) => {
                    this.dialog[params.index][openDialog] = false;
                  },
                },
              },
              [
                h(openDialog, {
                  props: params,
                }),
              ]
            );
            temp.push(modal);
            ite.data.on = {
              click: () => {
                this.dialog[params.index][openDialog] = true;
              },
            };
          }
        });

        return temp;
      };
    },
    //处理字段ValText和ValStyle属性
    // showStyle="Badge/Tag"
    handleColumnValTextStyle(item) {
      let valText = item.data.attrs["val-text"] || {};
      if (typeof valText == "string") {
        valText = JSON.parse(valText.replaceAll("'", '"'));
      }
      let valStyle = item.data.attrs["val-style"] || {};
      if (typeof valStyle == "string") {
        valStyle = JSON.parse(valStyle.replaceAll("'", '"'));
      }

      item.data.attrs["render"] = (h, params) => {
        let text =
          valText[params.row[item.data.attrs["key"]]] ||
          params.row[item.data.attrs["key"]];
        let style = valStyle[params.row[item.data.attrs["key"]]] || "success";
        let rlt;
        if (!text) {
          //空值处理
          return h("span", {
            domProps: {
              innerHTML: "",
            },
          });
        }
        if ("Badge" === item.data.attrs["show-style"]) {
          rlt = h("Badge", {
            props: {
              status: style,
              text: text,
            },
          });
        } else {
          rlt = h(
            "Tag",
            {
              props: {
                color: style,
              },
            },
            text
          );
        }
        return rlt;
      };
    },
    //处理字段DateFormat属性
    handleColumnDateFormat(item) {
      item.data.attrs["render"] = (h, params) => {
        let value = params.row[item.data.attrs["key"]] || "";
        if (!value) {
          return "";
        }
        if (("" + value).indexOf("-") != -1) {
          value = value.replaceAll("-", "/");
        }
        let format = item.data.attrs["date-format"] || "yyyy-MM-dd HH:mm";
        let text = new Date(value).format(format);

        let rlt = h("span", {
          domProps: {
            innerHTML: text,
          },
        });
        return rlt;
      };
    },
    //处理字段dict-key属性
    handleColumnDict(item) {
      item.data.attrs["render"] = (h, params) => {
        let value = params.row[item.data.attrs["key"]] || "";
        if (!value) {
          return "";
        }

        let dictKey = item.data.attrs["dict-key"];
        if (!dictKey) {
          return value;
        }

        let dict = this.dictMap[dictKey];
        if (!dict) {
          //没有的话就去获取字典数据
          Vue.set(this.dictMap, dictKey, {});
          dict = this.dictMap[dictKey];
          let url = "/sys/dataDict/getDictData";
          let post = Vue.abHttpUtil.postForm(url, {
            dictKey: dictKey,
          });
          Vue.abTools.getResultData(post, (data) => {
            data.forEach((node) => {
              Vue.set(dict, node.key, node.name);
            });
          });
        }

        let rlt = h("span", {
          domProps: {
            innerHTML: this.getDictText(dictKey, value),
          },
        });
        return rlt;
      };
    },
    //根据value转text
    getDictText(dictKey, value) {
      let list = [];
      value.split(",").forEach((str) => {
        list.push(this.dictMap[dictKey][str]);
      });
      return list.join(",");
    },
    //处理字段obj-key属性
    handleColumnObjKey(item) {
      item.data.attrs["render"] = (h, params) => {
        let objKey = item.data.attrs["obj-key"];
        let value;
        try {
          eval("value =params.row." + objKey);
        } catch (e) {
          value = "";
        }
        if (value == undefined) {
          value = "";
        }
        let rlt = h("span", {
          domProps: {
            innerHTML: value,
          },
        });
        return rlt;
      };
    },
    //处理key
    handleColumnKey(item) {
      item.data.attrs["render"] = (h, params) => {
        let value = params.row[item.data.attrs["key"]] || "";
        if (!value) {
          return "";
        }
        let titleValue =
          value.length > 60 ? value.substring(0, 60) + "..." : value;
        let rlt = h("span", {
          domProps: {
            innerHTML: titleValue,
            title: value,
          },
        });
        return rlt;
      };
    },
    // 清空所有已选项
    handleClearSelect() {
      this.$refs.selection.selectAll(false);
      this.selectedData = [];
      this.$emit("input", this.selectedData);
    },
    // 选中一项，将数据添加至已选项中
    handleSelect(selection, row) {
      row._checked = true;
      this.selectedData.push(row);
      this.$emit("input", this.selectedData);
    },
    // 取消选中一项，将取消的数据从已选项中删除
    handleSelectCancel(selection, row) {
      row._checked = false;
      const index = this.selectedData.findIndex((item) => item.id === row.id);
      this.selectedData.splice(index, 1);
      this.$emit("input", this.selectedData);
    },
    // 当前页全选时，判断已选数据是否存在，不存在则添加
    handleSelectAll(selection) {
      this.pageData.rows.forEach((item) => {
        item._checked = true;
        if (this.selectedData.findIndex((i) => i.id === item.id) < 0) {
          this.selectedData.push(item);
        }
      });
      this.$emit("input", this.selectedData);
    },
    // 取消当前页全选时，将当前页的数据（即 dataWithPage）从已选项中删除
    handleSelectAllCancel() {
      const selection = this.pageData.rows;
      selection.forEach((item) => {
        const index = this.selectedData.findIndex((i) => i.id === item.id);
        if (index >= 0) {
          this.selectedData.splice(index, 1);
        }
      });
      this.pageData.rows.forEach((item) => {
        item._checked = false;
      });
      //this.selectedData = [];
      this.$emit("input", this.selectedData);
    },
    handleInitData(pageData) {
      if (!pageData.rows) return;
      // 处理多层数据
      if (this.deepKeys.length > 0) {
        this.deepKeys.forEach((key) => {
          pageData.rows.forEach((item) => {
            item[key] = getValByScope({
              scope: item,
              exp: key,
            });
          });
        });
      }

      pageData.rows.forEach((item) => {
        const index = this.selectedData.findIndex((i) => i.id === item.id);
        if (index >= 0) {
          item._checked = true;
        }
      });
    },
  },
  watch: {
    changeTab: {
      handler: function(val) {
        // this.postPageData();
      },
      immediate: true,
      deep: true,
    },
    flush(n, o) {
      if (n != o) {
        this.postPageData();
      }
    },
  },
};
</script>
<style>
.ivu-table-row {
  cursor: pointer;
}
.ivu-table-cell {
  text-align: center;
}

.ivu-table {
  overflow-y: scroll;
}
/* 表格 清除横向坐标轴 */
.ivu-table-overflowX {
  overflow-x: hidden !important;
}

.ivu-table-tip {
  overflow: hidden;
}
</style>
